import { TypeKeys } from '../actions/index.js';
import type { ActionTypes } from '../actions/index.js';
import type { ActionsHistory, LayoutState } from '../common/store.js';

export function layoutReducer(
  state: (LayoutState & ActionsHistory) | undefined,
  action: ActionTypes
): (LayoutState & ActionsHistory) | null {
  if (typeof state === 'undefined') {
    return null;
  }

  switch (action.type) {
    case TypeKeys.FOOTER_SET_VISIBILITY: {
      return {
        ...state,
        hideHeaderFooter: !action.footerVisible,
        hasChanged: state === null || state.hideHeaderFooter !== action.footerVisible,
      };
    }

    case TypeKeys.SMALL_HEADER_SET_VISIBILITY: {
      return {
        ...state,
        hideSmallHeader: !action.smallHeaderVisible,
        hasChanged: state?.hideSmallHeader !== action.smallHeaderVisible,
      };
    }

    default:
      return state;
  }
}
